import { removeEnableFilterImageValues } from './removeEnableFilterImageValues.js';

export const cleanData = (emsData = {}) => removeEnableFilterImageValues(emsData);
